import experiments from '../../common/constants/experiments'

export default {
  name: '',
  domain: '',
  analytics: {
    google_conversion_id: '943617023',
    google_analytics_sandbox_id: 'UA-11834194-31'
  },
  google_tag_manager_id: 'GTM-585RXMV',
  google_optimize_container_id: 'GTM-5VPWWP',
  ui: {
    default_user_image_path: '/images/default-user.jpg',
    item_list_views: [
      {
        value: 'list',
        label: 'List'
      },
      {
        value: 'grid',
        label: 'Grid'
      }
    ],
    item_small_preview_paths: [
      'icon_with_landscape_preview.icon_url',
      'icon_with_square_preview.icon_url',
      'icon_with_video_preview.icon_url',
      'icon_with_audio_preview.icon_url',
      'icon_with_thumbnail_preview.icon_url',
      'thumbnail_preview.small_url',
      'icon_preview.icon_url'
    ],
    featured_hero_item_viewtype: 'list'
  },
  common: {
    search_page_size: 30,
    max_pages_count: 60
  },
  features: {
    /**
     * @description Decide whether to show sign up modal or render the sign up page.
     * @author Fraser Xu
     * @expires
     */
    'modal:signup': false,

    /**
     * @description Enables usage of external from shopfront frontent repo, shopfront api
     * @author Pawel Galazka and Fraser Xu
     * @expires when all endpoints migrated to /shopfront-api
     */
    'shopfront-api': false,

    /**
     * @description default sort order
     * @author Chris Hanson
     * @expires when default sort experiment finishes
     */
    defaultSortByBestSelling: false,
    defaultSortByBestRated: false,
    defaultSortByTrending: false,

    /**
     * @description Enables Smart Header behaviour (custom banner per page/category)
     * @author Pawel Galazka
     * @expires when smart header working successfully on production
     */
    'smart-header': false,

    /**
     * @description Global swither to turn off Cookiebot
     * @author Fraser Xu
     * @expires
     */
    turnOffCookiebot: false
  },
  assets_domains: {
    main: 'd2mdw063ttlqtq.cloudfront.net',
    main_alias: '0.s3.envato.com',
    user_profile: 'user-profile.s3.envato.com'
  },
  asset_type: 'item',
  search_query: {
    default_sort_by: 'date',
    default_sort_by_options: [
      {
        label: 'Best match',
        value: 'relevance'
      },
      {
        label: 'Trending items',
        value: 'trending'
      },
      {
        label: 'Best sellers',
        value: 'sales'
      },
      {
        label: 'Best rated',
        value: 'rating'
      },
      {
        label: 'Newest items',
        value: 'date'
      },
      {
        label: 'Price: low to high',
        value: 'price-asc'
      },
      {
        label: 'Price: high to low',
        value: 'price-desc'
      }
    ]
  },
  recommendations_limit: 8,
  show_category_in_selected_filters: false,
  min_price: 100,
  homepage: {
    newest_items_page_size: 40,
    newest_items_square: true
  },
  experiments_to_features: {
    [experiments.defaultSort]: {
      0: {
        defaultSortByBestSelling: false,
        defaultSortByBestRated: false,
        defaultSortByTrending: false
      },
      1: {
        defaultSortByBestSelling: false,
        defaultSortByBestRated: false,
        defaultSortByTrending: false
      },
      2: {
        defaultSortByBestSelling: true,
        defaultSortByBestRated: false,
        defaultSortByTrending: false
      },
      3: {
        defaultSortByBestSelling: true,
        defaultSortByBestRated: false,
        defaultSortByTrending: false
      },
      4: {
        defaultSortByBestSelling: false,
        defaultSortByBestRated: true,
        defaultSortByTrending: false
      },
      5: {
        defaultSortByBestSelling: false,
        defaultSortByBestRated: true,
        defaultSortByTrending: false
      },
      6: {
        defaultSortByBestSelling: false,
        defaultSortByBestRated: false,
        defaultSortByTrending: true
      },
      7: {
        defaultSortByBestSelling: false,
        defaultSortByBestRated: false,
        defaultSortByTrending: true
      }
    }
  }
}
